import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import AirlinesPageContent from "./AirlinesPageContent";
import { AirlinesPageHeading } from "./AirlinesPageHeading";
import { AirlinesNextPage } from "./AirlinesNextPage";
export const Airlines = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "airlinesPageHeading",
      children: <AirlinesPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "airlinesPageContent",
      children: <AirlinesPageContent/>
    },
    {
      label: "Next Page",
      key: "airlinesNextPage",
      children: <AirlinesNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
